import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { COLLECTION_URL } from "@/lib/site";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-xl border-b border-[#262626]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" data-testid="header-logo" className="flex items-center">
          <img
            src="/oya-logo.png"
            alt="Own Your Adventure"
            className="h-8 w-auto sm:h-10"
            draggable={false}
          />
        </a>

        <a
          data-testid="header-shop-btn"
          href={COLLECTION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group flex items-center gap-2 rounded-full border border-[#333] bg-white/5 px-4 py-2 font-cond text-sm font-semibold uppercase tracking-[0.15em] text-white transition-colors duration-300 hover:border-[#ee1111] hover:bg-[#ee1111] sm:px-5"
        >
          Shop Collection
          <ArrowUpRight
            size={16}
            className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </a>
      </div>
    </motion.header>
  );
};
